export default function ClientOriginLabels({ client, renderLabel = true }) {
  const origin = String(client?.originCliente || client?.origin || "").toLocaleLowerCase("pt-BR");
  const label = client?.originLabel || (
    ["lead", "lead/anúncio", "lead_anuncio"].includes(origin) ? "Lead · Anúncio"
      : ["porta", "presencial", "atendimento presencial"].includes(origin) ? "Presencial"
        : ["prospecção", "prospeccao"].includes(origin) ? "Prospecção"
          : ["indicação", "indicacao"].includes(origin) ? "Indicação" : client?.origin
  );
  const review = client?.originReviewLabel;
  const style = { fontSize:10, fontWeight:700, borderRadius:6, padding:"3px 7px", display:"inline-block" };
  return <>
    {renderLabel && label && <span style={{ ...style, color:"#334155", background:"#F1F5F9" }}>{label}</span>}
    {review && <span role="status" style={{ ...style, color:"#92400E", background:"#FEF3C7" }}>{review}</span>}
  </>;
}